import { render, staticRenderFns } from "./ReviewExpansionPanel.vue?vue&type=template&id=5720f758&scoped=true&"
import script from "./ReviewExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewExpansionPanel.vue?vue&type=style&index=0&id=5720f758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5720f758",
  null
  
)

export default component.exports